import { CancellationEndpoint } from '@acorn-portal/shared/src/pages/cancellation/types';

const PORTAL = '/portal/';
const ACCOUNT = '/account/';
const PAY_NOW = '/pay-now/';
const PAYMENT = '/payment/';
const PAYMENT_MANAGEMENT = '/payment-management';
const HOME = 'home';
const LOG_OUT = 'log-out';
const POLICY_DETAILS = 'policy-details';
const POLICY_DOCUMENTS = 'policy-documents';
const POLICY_RENEWAL = 'policy-renewals';
const OPTIONAL_EXTRAS = 'optional-extras';
const NOT_FOUND = 'not-found';
const REFERRAL = 'referral';
const ERROR = 'error';
const DECLINE = 'summary';
const TIME_OUT = 'time-out';
const HELP = 'help';
const REGISTER = 'register';
const RESEND_REGISTRATION = 'resend-registration';
const CHANGE_PASSWORD = 'change-password';
const MAKE_A_CHANGE = 'make-a-change';
const MAKE_A_CHANGE_ADDRESS = 'address';
const MAKE_A_CHANGE_VEHICLE = 'vehicle';
const MAKE_A_CHANGE_VEHICLE2 = 'vehicle-part2';
const MAKE_A_CHANGE_DRIVERS = 'drivers';
const MAKE_A_CHANGE_USAGE_AND_MILEAGE = 'usage-and-mileage';
const MAKE_A_CHANGE_USAGE_TAXI = 'usage-taxi';
const MAKE_A_CHANGE_SUMMARY = 'summary';
const MAKE_A_CHANGE_REFERRAL = 'referral';
const MAKE_A_CHANGE_PAYMENT_OPTIONS = 'payment-options';
const MAKE_A_CHANGE_PAYMENT_SUCCESS = 'payment-success';
const MAKE_A_CHANGE_TOP_UP_MILES_DATE = 'top-up-miles-date';
const MAKE_A_CHANGE_TOP_UP_MILES_PRICE = 'top-up-miles-price';
const MAKE_A_CHANGE_TOP_UP_MILES = 'top-up-miles';
const PAYMENT_PLAN = 'payment-schedule';
const SPLIT_PAYMENT_PLAN = 'split-payment-plan';
const OVERDUE_PLAN = 'overdue-schedule';
const PROCESS_PAYMENT = 'process-payment';
const CONFIRM_PAYMENT = 'confirmation';
const DIRECT_PAYMENT = 'direct-payment';
const DIRECT_DEBIT_PAYMENT = 'direct-debit-payment';
const DIRECT_PAYMENT_SUCCESS = 'direct-payment-success';
const CANX_PAYMENT_SUCCESS = 'canx-payment-success';
const CANX_OUTSTANDING_BALANCE = 'canx-balance';
const CANX_PAYMENT = 'canx-payment';
const CANX_POLICY = 'canx-policy';
const DIRECT_PAYMENT_CANX = 'direct-payment-canx';
const DIRECT_PAYMENT_CANX_SUCCESS = 'direct-payment-canx-success';
const RENEWAL_DETAILS = 'renewal';
const CHECKOUT = 'make-a-payment';
const CHECKOUT_SUCCESS = 'payment-success';
const EXPIRED_PAYMENT_LINK = 'expired-payment-link';
const INVALID_PAYMENT_LINK = 'invalid-payment-link';
const RENEWAL_REFERRAL = 'referral';
const RENEWAL_DISCLAIMER = 'disclaimer';
const MAKE_A_CHANGE_MILEAGE = 'mileage';
const DIRECT_AGREEMENT = 'payment-agreement-setup';
const MAKE_A_CHANGE_BANK_DETAILS = 'change-bank-details';
const MAKE_A_CHANGE_PAYMENT_DATE = 'change-payment-date';
const MAKE_A_CHANGE_PAYMENT_DATE_SUCCESS = 'change-payment-date-success';
const FULL_PAYMENT_SCHEDULE = 'full-payment-schedule';
const CHANGE_BANK_DETAILS_SUCCESS = 'change-bank-details-success';
const CHANGE_BANK_DETAILS_ERROR = 'change-bank-details-error';
const BACK_OFFICE_SESSION_PAYMENT = 'session-payment';
const BACK_OFFICE_SESSION_PAYMENT_SUCCESS = 'session-payment-success';
const SUBSCRIPTION_RESTART = 'subscription-restart';
const SUBSCRIPTION_RESTART_SUMMARY = 'summary';
const SUBSCRIPTION_RESTART_AMEND_VEHICLE_1 = 'amend-vehicle-1';
const SUBSCRIPTION_RESTART_AMEND_VEHICLE_2 = 'amend-vehicle-2';
const SUBSCRIPTION_RESTART_AMEND_ADDRESS = 'amend-address';
const SUBSCRIPTION_RESTART_AMEND_DRIVERS = 'amend-drivers';
const SUBSCRIPTION_RESTART_AMEND_USAGE = 'amend-usage';
const SUBSCRIPTION_RESTART_PAYMENT_OPTIONS = 'payment-options';
const SUBSCRIPTION_RESTART_PAYMENT_SUCCESS = 'payment-success';
const SUBSCRIPTION_RESTART_REFERRAL = 'referral';
const CANCELLATION = 'cancellation';
const CANCELLATION_REASON: CancellationEndpoint = 'reason';
const CANCELLATION_DATE: CancellationEndpoint = 'date';
const CANCELLATION_CONFIRMATION: CancellationEndpoint = 'confirm';
const CANCELLATION_SUCCESS: CancellationEndpoint = 'success';
const TRIPS = 'trips';
const TRIP_DETAILS = 'trips/:tripId';

export const ROUTE_PATHS = {
	home: `${PORTAL}${HOME}`,
	logOut: `${PORTAL}${LOG_OUT}`,
	help: `${PORTAL}${HELP}`,
	policyDetails: `${PORTAL}${POLICY_DETAILS}`,
	policyDocuments: `${PORTAL}${POLICY_DOCUMENTS}`,
	policyRenewals: `${PORTAL}${POLICY_RENEWAL}`,
	policyRenewalRefer: `${PORTAL}${POLICY_RENEWAL}/refer`,
	changePassword: `${PORTAL}${CHANGE_PASSWORD}`,
	renewalDisclaimer: `${PORTAL}${POLICY_RENEWAL}/${RENEWAL_DISCLAIMER}`,
	renewalMakeAChangeHome: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}`,
	renewalMakeAChangeAddress: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_ADDRESS}`,
	renewalOptionalExtras: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${OPTIONAL_EXTRAS}`,
	renewalMakeAChangeDrivers: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_DRIVERS}`,
	renewalMakeAChangeUsageAndMileage: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_USAGE_AND_MILEAGE}`,
	renewalMakeAChangeVehicle: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_VEHICLE}`,
	renewalMakeAChangeVehicle2: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_VEHICLE2}`,
	renewalMakeAChangeSummary: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_SUMMARY}`,
	renewalMakeAChangePaymentOptions: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_PAYMENT_OPTIONS}`,
	renewalMakeAChangePaymentSuccess: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${MAKE_A_CHANGE_PAYMENT_SUCCESS}`,
	renewalMakeAChangeReferral: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE}/${RENEWAL_REFERRAL}`,
	renewalMakeAChangeUsageTaxi: `${PORTAL}${POLICY_RENEWAL}/${MAKE_A_CHANGE_USAGE_TAXI}`,
	makeAChangeHome: `${PORTAL}${MAKE_A_CHANGE}`,
	makeAChangeAddress: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_ADDRESS}`,
	makeAChangeDrivers: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_DRIVERS}`,
	makeAChangeUsageAndMileage: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_USAGE_AND_MILEAGE}`,
	makeAChangeUsageTaxi: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_USAGE_TAXI}`,
	makeAChangeVehicle: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_VEHICLE}`,
	makeAChangeVehicle2: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_VEHICLE2}`,
	makeAChangeSummary: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_SUMMARY}`,
	makeAChangeReferral: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_REFERRAL}`,
	makeAChangePaymentOptions: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_PAYMENT_OPTIONS}`,
	makeAChangePaymentSuccess: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_PAYMENT_SUCCESS}`,
	makeAChangeMileage: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_MILEAGE}`,
	referral: `${PORTAL}${REFERRAL}`,
	error: `${PORTAL}${ERROR}`,
	unauthorisedError: `/err/${ERROR}`,
	decline: `${PORTAL}${DECLINE}`,
	timeOut: `${PORTAL}${TIME_OUT}`,
	notFound: `${PORTAL}${NOT_FOUND}`,
	register: `${ACCOUNT}${REGISTER}`,
	resendRegistration: `${ACCOUNT}${RESEND_REGISTRATION}`,
	paymentPlan: `${PAY_NOW}${PAYMENT_PLAN}`,
	splitPaymentPlan: `${PAY_NOW}${SPLIT_PAYMENT_PLAN}`,
	paymentPlanOverdue: `${PAY_NOW}${OVERDUE_PLAN}`,
	processPayment: `${PAY_NOW}${PROCESS_PAYMENT}`,
	payNowConfirmation: `${PAY_NOW}${CONFIRM_PAYMENT}`,
	payNowSPDirectPayment: `${PAY_NOW}${DIRECT_PAYMENT}`,
	payNowDirectAgreement: `${PAYMENT}${DIRECT_AGREEMENT}`,
	payNowDirectPayment: `${PAYMENT}${DIRECT_PAYMENT}`,
	payNowDirectDebitPayment: `${PAYMENT}${DIRECT_DEBIT_PAYMENT}`,
	payNowDirectPaymentSuccess: `${PAYMENT}${DIRECT_PAYMENT_SUCCESS}`,
	expiredPaymentLink: `${PAYMENT}${EXPIRED_PAYMENT_LINK}`,
	invalidPaymentLink: `${PAYMENT}${INVALID_PAYMENT_LINK}`,
	canxOutstandingBalance: `${PAY_NOW}${CANX_OUTSTANDING_BALANCE}`,
	canxCancelledPolicy: `${PAY_NOW}${CANX_POLICY}`,
	canxPayment: `${PAY_NOW}${CANX_PAYMENT}`,
	canxPaymentSuccess: `${PAY_NOW}${CANX_PAYMENT_SUCCESS}`,
	canxDirectPayment: `${PAYMENT}${DIRECT_PAYMENT_CANX}`,
	canxDirectPaymentSuccess: `${PAYMENT}${DIRECT_PAYMENT_CANX_SUCCESS}`,
	renewalDetails: `${PORTAL}${RENEWAL_DETAILS}`,
	renewalCheckout: `${PORTAL}${POLICY_RENEWAL}/${CHECKOUT}`,
	renewalCheckoutSuccess: `${PORTAL}${POLICY_RENEWAL}/${CHECKOUT_SUCCESS}`,
	paymentManagementChangeBankDetails: `${PAYMENT_MANAGEMENT}/${MAKE_A_CHANGE_BANK_DETAILS}`,
	paymentManagementChangePaymentDate: `${PAYMENT_MANAGEMENT}/${MAKE_A_CHANGE_PAYMENT_DATE}`,
	paymentManagementChangePaymentDateSuccess: `${PAYMENT_MANAGEMENT}/${MAKE_A_CHANGE_PAYMENT_DATE_SUCCESS}`,
	changeBankSuccess: `${PAYMENT_MANAGEMENT}/${CHANGE_BANK_DETAILS_SUCCESS}`,
	fullPaymentSchedule: `${PAYMENT_MANAGEMENT}/${FULL_PAYMENT_SCHEDULE}`,
	changeBankError: `${PAYMENT_MANAGEMENT}/${CHANGE_BANK_DETAILS_ERROR}`,
	backOfficePaymentSession: `${PAYMENT}${BACK_OFFICE_SESSION_PAYMENT}`,
	backOfficePaymentSessionSuccess: `${PAYMENT}${BACK_OFFICE_SESSION_PAYMENT_SUCCESS}`,
	subscriptionRestart: `${PORTAL}${SUBSCRIPTION_RESTART}`,
	subscriptionRestartSummary: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_SUMMARY}`,
	subscriptionRestartAmendVehicle1: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_AMEND_VEHICLE_1}`,
	subscriptionRestartAmendVehicle2: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_AMEND_VEHICLE_2}`,
	subscriptionRestartAmendAddress: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_AMEND_ADDRESS}`,
	subscriptionRestartAmendDrivers: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_AMEND_DRIVERS}`,
	subscriptionRestartAmendUsage: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_AMEND_USAGE}`,
	subscriptionRestartPaymentOptions: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_PAYMENT_OPTIONS}`,
	subscriptionRestartPaymentSuccess: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_PAYMENT_SUCCESS}`,
	subscriptionRestartReferral: `${PORTAL}${SUBSCRIPTION_RESTART}/${SUBSCRIPTION_RESTART_REFERRAL}`,
	topUpMilesDate: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_TOP_UP_MILES_DATE}`,
	topUpMilesPrice: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_TOP_UP_MILES_PRICE}`,
	topUpMiles: `${PORTAL}${MAKE_A_CHANGE}/${MAKE_A_CHANGE_TOP_UP_MILES}`,
	cancellation: `${PORTAL}${CANCELLATION}`,
	cancellationReason: `${PORTAL}${CANCELLATION}/${CANCELLATION_REASON}`,
	cancellationDate: `${PORTAL}${CANCELLATION}/${CANCELLATION_DATE}`,
	cancellationConfirmation: `${PORTAL}${CANCELLATION}/${CANCELLATION_CONFIRMATION}`,
	cancellationSuccess: `${PORTAL}${CANCELLATION}/${CANCELLATION_SUCCESS}`,
	telematicsTrips: `${PORTAL}${TRIPS}`,
	telematicsTripDetails: `${PORTAL}${TRIP_DETAILS}`,
} as const;

type RouteKey = keyof typeof ROUTE_PATHS;
export type RoutePath = (typeof ROUTE_PATHS)[RouteKey];
